export const vehicleAxles = {
    MOTOCICLETA: 2,
    MOTOCARRO: 2,
    CAMIONETA: 2,
    AUTOMOVIL: 2
}